/*@ngInject*/
const loadSubmissionsRepository = function (baseRepository, $q) {

    angular.extend(this, baseRepository);

    const translationTable = {
        insuredName: 'insured.name',
        number: 'submissionNumber',
        premium: 'totalPremium.total',
        nextAction: 'nextTask.definition'
    };

    this.loadSubmissions = function (submissionParams) {
        const url = '/rest/Submission/filter',
            sortColumn = translationTable[submissionParams.key] || submissionParams.key,
            config = {
                params: {
                    filterUri: submissionParams.filterUri,
                    resultType: 'grid',
                    startIndex: submissionParams.startIndex,
                    numberOfRows: submissionParams.pageSize,
                    sortBy: `${sortColumn} ${submissionParams.sortType}`
                }
            };
        this.lastLoadSubmissionsConfig = config;

        if (sortColumn === 'submissionNumber') {
            config.params.sortBy = `policyNumber ${submissionParams.sortType}, submissionNumber ${submissionParams.sortType}`;
        }

        return $q(function(resolve, reject) {
          this.get(url, config).then(
            function sucess(r) {
              if (this.lastLoadSubmissionsConfig==config)
                resolve(r);
            }.bind(this),
            function error(e) {
              reject(e);
            }
          )
        }.bind(this));
    }.bind(this);

};

angular.module('gw-um-submission-grid')
    .service('loadSubmissionsRepository', loadSubmissionsRepository);
